export function speakFrench(text) {
  if (!text || typeof window === "undefined" || !window.speechSynthesis) return;

  const utter = new SpeechSynthesisUtterance(text);
  utter.lang = "fr-FR";
  utter.rate = 0.95;

  window.speechSynthesis.cancel();
  window.speechSynthesis.speak(utter);
}